import NotFound from 'pages/404'
import AccountPage from 'pages/Account'
import AccountDetail from 'pages/Account/Detail'
import AccountRegister from 'pages/Account/Register'
import Event from 'pages/Event'
import EventDetail from 'pages/Event/Detail'
import EventResult from 'pages/Event/Result'
import Feedback from 'pages/Feedback'
import FeedbackDetail from 'pages/Feedback/Detail'
import FeedbackRegister from 'pages/Feedback/Register'
import Home from 'pages/Home'
import Login from 'pages/Login'
import News from 'pages/News'
import NewsDetail from 'pages/News/Detail'
import NewsRegister from 'pages/News/Register'
import Organizer from 'pages/Organizer'
import OrganizerRegister from 'pages/Organizer/Register'
import Quiz from 'pages/Quiz'
import QuizRegister from 'pages/Quiz/Register'

interface RouterData {
  path: string
  element: () => JSX.Element | null
  useLayout?: boolean
}

export const publicRoutes: RouterData[] = [
  {
    path: '*',
    element: NotFound,
    useLayout: true,
  },
]

export const authRoutes: RouterData[] = [
  {
    path: '/login',
    element: Login,
    useLayout: true,
  },
]

export const privateRoutes: RouterData[] = [
  {
    path: '/organizer/register',
    element: OrganizerRegister,
    useLayout: true,
  },
  {
    path: '/organizer',
    element: Organizer,
    useLayout: true,
  },
  {
    path: '/event/:id/result',
    element: EventResult,
    useLayout: true,
  },
  {
    path: '/event/:id',
    element: EventDetail,
    useLayout: true,
  },
  {
    path: '/event',
    element: Event,
    useLayout: true,
  },
  {
    path: '/quiz/register',
    element: QuizRegister,
    useLayout: true,
  },
  {
    path: '/quiz',
    element: Quiz,
    useLayout: true,
  },
  {
    path: '/account/register',
    element: AccountRegister,
    useLayout: true,
  },
  {
    path: '/account',
    element: AccountPage,
    useLayout: true,
  },
  {
    path: '/account/:id',
    element: AccountDetail,
    useLayout: true,
  },
  {
    path: '/feedback',
    element: Feedback,
    useLayout: true,
  },
  {
    path: '/feedback/register',
    element: FeedbackRegister,
    useLayout: true,
  },
  {
    path: '/feedback/:id',
    element: FeedbackDetail,
    useLayout: true,
  },
  {
    path: '/news',
    element: News,
    useLayout: true,
  },
  {
    path: '/news/register',
    element: NewsRegister,
    useLayout: true,
  },
  {
    path: '/news/:id',
    element: NewsDetail,
    useLayout: true,
  },
  {
    path: '/',
    element: Home,
    useLayout: true,
  },
]
